(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[780],{

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Options_UpdateBasicOptions; }
});

// UNUSED EXPORTS: UpdateBasicOptions

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/fields/DeliveryType/index.tsx
var DeliveryType = __webpack_require__(35438);
// EXTERNAL MODULE: ./src/components/LoadingText/index.tsx + 1 modules
var LoadingText = __webpack_require__(69840);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/helpers/websites/withWebsiteId.tsx
var withWebsiteId = __webpack_require__(91015);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withMessage.js
var withMessage = __webpack_require__(77543);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withGraphQL.js
var withGraphQL = __webpack_require__(70791);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withMutation.js
var withMutation = __webpack_require__(68688);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx
var StoreName = __webpack_require__(59450);
// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var dist_esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var simple_react_form_lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/index.tsx
var Update = __webpack_require__(89435);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/Time/index.tsx
var Time = __webpack_require__(84339);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/DeliveryOptions/styles.module.css
var styles_module = __webpack_require__(1159);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/DeliveryOptions/index.tsx





function DeliveryOptions(param) {
    var preferences = param.preferences, isFromHeader = param.isFromHeader, layout = param.layout;
    var address = preferences.address, store = preferences.store, placeId = preferences.placeId;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var time = store && address && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).selectTime,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Time/* default */.Z, {
            preferences: preferences,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            showDirections: !!placeId && placeId !== "no-deliver"
        })
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Update/* default */.Z, {
        preferences: preferences,
        autoSave: true,
        showOutOfBoundsMsg: true,
        showMapRight: layout === "v1" ? false : true,
        isFromHeader: isFromHeader,
        time: time,
        loading: loading,
        setLoading: setLoading
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/StoreMessage/index.tsx
var StoreMessage = __webpack_require__(13467);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/TableName/index.tsx + 1 modules
var TableName = __webpack_require__(99590);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/styles.module.css
var UpdateBasicOptions_styles_module = __webpack_require__(60170);
var UpdateBasicOptions_styles_module_default = /*#__PURE__*/__webpack_require__.n(UpdateBasicOptions_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    query getDataForBasicInfo($websiteId: ID) {\n      stores(websiteId: $websiteId) {\n        items {\n          label: name\n          value: _id\n          acceptServe\n          acceptGo\n          schedulingOrdersDays\n          address {\n            placeId\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  mutation setPreferencesBasicOptions(\n    $websiteId: ID\n    $storeId: ID\n    $placeId: ID\n    $deliveryType: ID\n  ) {\n    setUserPreferences(\n      websiteId: $websiteId\n      storeId: $storeId\n      placeId: $placeId\n      deliveryType: $deliveryType\n    ) {\n      _id\n      deliveryType\n      timeLabel\n      time\n      itsStoreOpenAtTime\n      placeId\n      menuId\n      tableName\n      directions {\n        duration\n      }\n      website {\n        _id\n        name\n      }\n      websiteId\n      storeId\n      deliverAt\n      time\n      channel\n      shouldHidePrice\n      store {\n        _id\n        name\n        schedule {\n          itsOpenNow: itsAvailableAt(websiteId: $websiteId, storeId: $storeId)\n        }\n        schedulingOrdersDays\n        minimumAnticipationDays\n        currentPreparationDuration\n        currentDeliveryDuration\n        timeFormat\n        availableScheduleDaysOptions {\n          label\n          value\n        }\n        nextAvailableDate\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* eslint-disable @typescript-eslint/ban-types */ 






















var _class, _dec, _dec1;
var _dec2 = (0,withGraphQL["default"])((0,lib["default"])(_templateObject()), {
    loading: null
}), _dec3 = (0,withMutation["default"])((0,lib["default"])(_templateObject1()));
var UpdateBasicOptions = _class = _dec3(_class = (0,withWebsiteId/* default */.Z)(_class = _dec2(_class = (0,withMessage/* default */.Z)(((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(UpdateBasicOptions, _Component);
    var _super = _createSuper(UpdateBasicOptions);
    function UpdateBasicOptions() {
        _classCallCheck(this, UpdateBasicOptions);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loading: false
        };
        return _this;
    }
    var _proto = UpdateBasicOptions.prototype;
    _proto.onChange = function onChange(params) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var fields, final;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (_this.props.preferences.websiteId) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        fields = [
                            "websiteId",
                            "storeId",
                            "placeId",
                            "deliveryType"
                        ];
                        final = pick_default().apply(void 0, [
                            _objectSpread({}, _this.props.preferences, params)
                        ].concat(_toConsumableArray(fields)));
                        if (!isEqual_default()(pick_default().apply(void 0, [
                            _this.props.preferences
                        ].concat(_toConsumableArray(fields))), final)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        _this.setState({
                            loading: true
                        });
                        _ctx.next = 10;
                        return _this.props.setPreferencesBasicOptions(final, {
                        });
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.props.showMessage(_ctx.t0);
                    case 15:
                        _this.setState({
                            loading: false
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }))();
    };
    _proto.renderStore = function renderStore() {
        var _props = this.props, _stores = _props.stores, stores = _stores === void 0 ? {
            items: []
        } : _stores, _preferences = _props.preferences, preferences = _preferences === void 0 ? {} : _preferences;
        var deliveryType = preferences.deliveryType;
        if (!deliveryType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMessage/* default */.Z, {
                preferences: preferences
            });
        }
        var filteredStores = stores.items.filter(function(store) {
            if (!store.address || !store.address.placeId) {
                return false;
            }
            if (deliveryType === "go" && store.acceptGo) {
                return true;
            }
            if (deliveryType === "serve" && store.acceptServe) {
                return true;
            }
            return false;
        });
        if (filteredStores.length === 1) {
            if (!this.props.preferences) return;
            if (this.state.loading) return;
            if (this.props.preferences.storeId !== filteredStores[0].value) {
                var _this = this;
                setTimeout(function() {
                    return _this.onChange({
                        storeId: filteredStores[0].value
                    });
                }, 0);
            }
            return;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
            fieldName: "storeId",
            label: this.props.t("order.options.updateBasicOptions.labelChooseStore"),
            placeholder: this.props.t("order.options.updateBasicOptions.labelSelectStore"),
            type: Select/* default */.Z,
            className: (UpdateBasicOptions_styles_module_default()).addressSelector,
            options: filteredStores
        });
    };
    _proto.renderTime = function renderTime() {
        var _preferences = this.props.preferences, placeId = _preferences.placeId, deliveryType = _preferences.deliveryType, store = _preferences.store, time = _preferences.time;
        if (!store) return;
        if (deliveryType === "serve" && !store.acceptServeSchedulingOrders) return;
        if (deliveryType === "serve" && time === "now") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Time/* default */.Z, {
            preferences: this.props.preferences,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            showDirections: !!placeId && placeId !== "no-deliver"
        });
    };
    _proto.renderTableName = function renderTableName() {
        var _preferences = this.props.preferences, deliveryType = _preferences.deliveryType, store = _preferences.store, time = _preferences.time;
        if (!store) return;
        if (deliveryType !== "serve") return;
        if (time !== "now") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableName/* default */.Z, {
            preferences: this.props.preferences
        });
    };
    _proto.renderDeliveryOptions = function renderDeliveryOptions() {
        var loading = this.state.loading;
        if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {
            lines: 2
        });
        var deliveryType = this.props.preferences.deliveryType;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                deliveryType === "delivery" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryOptions, {
                    preferences: this.props.preferences,
                    isFromHeader: this.props.isFromHeader,
                    layout: this.props.layout
                }),
                deliveryType !== "delivery" && this.renderStore(),
                deliveryType !== "delivery" && this.renderTime(),
                deliveryType !== "delivery" && this.renderTableName()
            ]
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {}),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (UpdateBasicOptions_styles_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(simple_react_form_lib.Form, {
                    state: this.props.preferences,
                    onChange: this.onChange,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                            fieldName: "deliveryType",
                            type: DeliveryType/* default */.Z,
                            disabled: this.state.loading
                        }),
                        this.renderDeliveryOptions(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName/* default */.Z, {
                            preferences: this.props.preferences,
                            website: {
                                showStoreName: this.props.showStoreName
                            },
                            isOnMenu: true
                        })
                    ]
                })
            })
        });
    };
    return UpdateBasicOptions;
}(react.Component)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "onChange", [
    esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class)) || _class) || _class) || _class) || _class;
/* harmony default export */ var Options_UpdateBasicOptions = ((0,dist_esm/* withTranslation */.Zh)()((0,router.withRouter)(UpdateBasicOptions)));


/***/ }),

/***/ 98751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getClient; }
/* harmony export */ });
/* harmony import */ var _providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40565);

function getClient() {
    var clientName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "main";
    var clients = (0,_providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return clients[clientName];
};


/***/ }),

/***/ 1159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectTime":"_1DFpNFlSSkQcsaOUrf54qN"};

/***/ }),

/***/ 60170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OWNo-JhqksOSn4oJWLbNb","label":"_1G7h8kGxYCt5SHAWliz3Kx","containerIcon":"_20m7mdxd-bsZiE04e409gL","addressSelector":"_1wCQDS2mswBxGlqQ8a8N0l"};

/***/ })

}]);